/**
 * Created by Angelika on 01.09.2017.
 */
import React, {Component} from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import * as strings from '../constants/strings';

class SettingList extends Component {

    menuClick(tag) {
        const {onItemClick} = this.props;
        onItemClick(tag);

        switch (tag) {
            case "user":
                break;

            default:
                break;
        }
    }

    render() {
        const {itemActive} = this.props;
        return (
            <ul className="sub-menu">
                <li className={itemActive === "user" ? "active" : ""}>
                    <Link to={'/user'} data-tag="user" onClick={() => this.menuClick("user")}>{strings.STR_MENU_USER}</Link>
                </li>
            </ul>
        )
    }
}

SettingList.propTypes = {
    itemActive: PropTypes.string.isRequired,
    onItemClick: PropTypes.func.isRequired
};

export default SettingList;


// WEBPACK FOOTER //
// ./src/components/SettingList.js